import React from "react";
import Box from "@mui/material/Box";

import colors from "../../../constants/colors.ts";
import MainLayout from "../../MainLayout.tsx";
import useStyles from "../../../hooks/styles.hook.tsx";
import LinkGrid from "../../../components/grids/linkGrid.component.tsx";
import { ColorsType } from "../../../types/colors.types.ts";
import TextBox from "../../../components/text/textBox.component.tsx";
import { textTypes } from "../../../constants/app.constants.ts";
import { servicesGridItems } from "../../../constants/grids.contants.ts";

const Section13: React.FC = () => {
  const { verticalPaddingBoxStyles, smallMarginBottomStyles } = useStyles();

  return (
    <MainLayout backgroundColor={colors.PINK_F4F4FB} isFooterDisplayed={true}>
      <Box sx={verticalPaddingBoxStyles} textAlign={"center"}>
        <TextBox
          variant={textTypes.TITLE}
          text={"TITLE.PacheteDeServicii"}
          sx={smallMarginBottomStyles}
        />

        <LinkGrid
          columnsNumber={4}
          items={servicesGridItems}
          itemBackgroundColour={colors.WHITE}
          iconColour={ColorsType.BLUE}
        />
      </Box>
    </MainLayout>
  );
};

export default Section13;
